"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("../../../private/services/channel/channel");
var PublicChannel = /** @class */ (function () {
    function PublicChannel(_a) {
        var _b = _a === void 0 ? {} : _a, privateServiceConfig = _b.privateServiceConfig, youtubeServiceConfig = _b.youtubeServiceConfig;
        this.privateService = new channel_1.PrivateChannel({
            privateServiceConfig: privateServiceConfig,
            youtubeServiceConfig: youtubeServiceConfig,
        });
    }
    PublicChannel.prototype.getAxiosInstance = function () {
        return this.privateService.getAxiosInstance();
    };
    /**
     * Returns a list of purchases made by currently active user
     * @param {string} channelId
     * @param {string} instance
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<MemberInfoResponse>}
     */
    PublicChannel.prototype.getMemberInfo = function (channelId, instance, requestConfig) {
        return this.privateService.getPublicMemberInfo(channelId, instance, requestConfig);
    };
    /**
     * If channel has a video preview feature active, used to return videoUrls for channel cover video-file
     * @param {string} channelId
     * @param {string} instance
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<VideoUrlsResponse>}
     */
    PublicChannel.prototype.getVideoPreviewUrls = function (channelId, instance, requestConfig) {
        return this.privateService.getPublicVideoPreviewUrls(channelId, instance, requestConfig);
    };
    /**
     * Returns channel response (similar to PrivateChannel entity)
     * @param channelId
     * @param extraOptions
     * @param requestConfig
     * @return AxiosPromise
     */
    PublicChannel.prototype.getInfo = function (channelId, extraOptions, requestConfig) {
        return this.privateService.getPublicInfo(channelId, extraOptions, requestConfig);
    };
    /**
     * Fetch YT channel by VOD's channel
     * @param channel
     */
    PublicChannel.prototype.getExternalChannelInfo = function (channel) {
        return this.privateService.fetchExternalSingleItem(channel);
    };
    return PublicChannel;
}());
exports.PublicChannel = PublicChannel;
//# sourceMappingURL=channel.js.map